import { Stack, Typography } from "@mui/material";
import { ReactNode } from "react";

type Props = {
  children: ReactNode;
  title: string;
  label: string;
  gap?: string;
  isRequired?: boolean;
};

export const LabelWrapper = ({
  children,
  label,
  title,
  gap = "8px",
  isRequired,
}: Props) => (
  <Stack gap={gap}>
    <Stack>
      <Typography variant="subtitle1" fontWeight="500">
        {title}
        {isRequired && (
          <span style={{ color: "#1C3C6C", marginLeft: "2px" }}>*</span>
        )}
      </Typography>
      <Typography variant="body1" color="text.secondary">
        {label}
      </Typography>
    </Stack>
    {children}
  </Stack>
);
